import { render, staticRenderFns } from "./ModalErrorRutValidation.vue?vue&type=template&id=267e7684&scoped=true&"
import script from "./ModalErrorRutValidation.vue?vue&type=script&lang=js&"
export * from "./ModalErrorRutValidation.vue?vue&type=script&lang=js&"
import style0 from "./ModalErrorRutValidation.vue?vue&type=style&index=0&id=267e7684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e7684",
  null
  
)

export default component.exports